import { render, staticRenderFns } from "./ShrimpDeathMap.vue?vue&type=template&id=059ef0ff&"
import script from "./ShrimpDeathMap.vue?vue&type=script&lang=js&"
export * from "./ShrimpDeathMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports